<div class="auth-header">SIGN IN</div>

<div [ngClass]="{ 'flex-container': isDesktopCartPage }">
    <div class="login-flex">
        <app-main-mobile-number></app-main-mobile-number>
    </div>

    @if (sdkLoaded) {
        <div class="divider">
            <div class="text-center" [ngClass]="{ 'sign-in-or': isDesktopCartPage, or: !isDesktopCartPage }">or</div>
        </div>
    }

    <div class="third-party-login">
        <!-- loader for Google btn -->
        @if (showLoader) {
            <div>
                <div class="space-20"></div>
                <button class="login-btn google-btn radius-3">
                    <div class="google-btn-text">
                        <ng-container>
                            <mat-spinner class="red-spinner"></mat-spinner>
                        </ng-container>
                    </div>
                </button>
                <div class="space-20"></div>
            </div>
        }

        <div style="display: none; justify-content: center; margin: 10px" [ngStyle]="sdkLoaded ? { display: 'flex' } : {}">
            <div id="google_signin" #googleBtn></div>
        </div>
    </div>
</div>

<p class="login-terms" [ngClass]="{ 'unset-login-terms': isDesktopCartPage }">
    By signing in, you agree to the <span class="tnc" (click)="navigateToTnc()">Terms and Conditions</span>
</p>
